"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositSingleAssetTxb = depositSingleAssetTxb;
exports.depositDoubleAssetTxb = depositDoubleAssetTxb;
exports.getLiquidity = getLiquidity;
exports.getAmounts = getAmounts;
exports.getCoinAmountsFromLiquidity = getCoinAmountsFromLiquidity;
exports.getEstimatedGasBudget = getEstimatedGasBudget;
const tslib_1 = require("tslib");
const transactions_1 = require("@mysten/sui/transactions");
const maps_js_1 = require("../common/maps.js");
const alpha_js_1 = require("./alpha.js");
const navi_js_1 = require("./navi.js");
const bucket_js_1 = require("./bucket.js");
const cetus_js_1 = require("./cetus.js");
const bluefin_js_1 = require("./bluefin.js");
const navi_looping_js_1 = require("./navi-looping.js");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const getReceipts_js_1 = require("../sui-sdk/functions/getReceipts.js");
const client_js_1 = require("../sui-sdk/client.js");
const alphalend_js_1 = require("./alphalend.js");
async function depositSingleAssetTxb(poolName, address, amount) {
    let txb = new transactions_1.Transaction();
    if (maps_js_1.poolInfo[poolName].parentProtocolName === "ALPHAFI") {
        txb = await (0, alpha_js_1.depositAlphaTxb)(amount, address);
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "BUCKET") {
        txb = await (0, bucket_js_1.bucketDepositTx)(amount, { address });
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "NAVI") {
        if (maps_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            txb = await (0, navi_looping_js_1.loopingDeposit)(poolName, amount, { address });
        }
        else {
            txb = await (0, navi_js_1.naviDepositTx)(amount, poolName, { address });
        }
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        if (maps_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            txb = await (0, alphalend_js_1.alphalendLoopingDeposit)(poolName, amount, { address });
        }
        else if (maps_js_1.poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
            txb = await (0, alphalend_js_1.alphalendSingleLoopDeposit)(poolName, amount, {
                address: address,
            });
        }
    }
    txb.setSender(address);
    const estimatedGasBudget = await getEstimatedGasBudget(txb, address);
    if (estimatedGasBudget)
        txb.setGasBudget(estimatedGasBudget);
    return txb;
}
async function depositDoubleAssetTxb(poolName, address, amount, isAmountA) {
    let txb = new transactions_1.Transaction();
    const coin1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coin2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    if (maps_js_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        if (coin1 === "CETUS" && coin2 === "SUI") {
            txb = await (0, cetus_js_1.depositCetusSuiTxb)(amount, poolName, isAmountA, { address });
        }
        else if (coin2 === "SUI") {
            txb = await (0, cetus_js_1.depositCetusAlphaSuiTxb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else {
            txb = await (0, cetus_js_1.depositCetusTxb)(amount, poolName, isAmountA, { address });
        }
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb = await (0, bluefin_js_1.depositBluefinFungibleTxb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI" ||
            poolName === "BLUEFIN-ALPHA-USDC" ||
            poolName === "BLUEFIN-BLUE-USDC") {
            txb = await (0, bluefin_js_1.depositBluefinType2Txb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else if (coin1 === "SUI") {
            txb = await (0, bluefin_js_1.depositBluefinSuiFirstTxb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else if (coin2 === "SUI") {
            txb = await (0, bluefin_js_1.depositBluefinSuiSecondTxb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else if (coin1 === "STSUI" || coin2 === "STSUI") {
            txb = await (0, bluefin_js_1.depositBluefinStsuiTxb)(amount, poolName, isAmountA, {
                address,
            });
        }
        else {
            txb = await (0, bluefin_js_1.depositBluefinType1Txb)(amount, poolName, isAmountA, {
                address,
            });
        }
    }
    txb.setSender(address);
    const estimatedGasBudget = await getEstimatedGasBudget(txb, address);
    if (estimatedGasBudget)
        txb.setGasBudget(estimatedGasBudget);
    return txb;
}
async function getLiquidity(poolName, a2b, amount, ignoreCache = true) {
    const cetusInvestor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
    const cetus_pool = await (0, getReceipts_js_1.getParentPool)(poolName, ignoreCache);
    //TODO
    //check if you calculate lower_tick, upper_tick like this only
    const upper_bound = 443636;
    let lower_tick = Number(cetusInvestor.content.fields.lower_tick);
    let upper_tick = Number(cetusInvestor.content.fields.upper_tick);
    if (lower_tick > upper_bound) {
        lower_tick = -~(lower_tick - 1);
    }
    if (upper_tick > upper_bound) {
        upper_tick = -~(upper_tick - 1);
    }
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    const current_sqrt_price = new bn_js_1.default(cetus_pool.content.fields.current_sqrt_price);
    const liquidity = cetus_sui_clmm_sdk_1.ClmmPoolUtil.estLiquidityAndcoinAmountFromOneAmounts(lower_tick, upper_tick, new bn_js_1.default(`${Math.floor(parseFloat(amount))}`), a2b, false, 0.5, current_sqrt_price);
    return liquidity;
}
async function getAmounts(poolName, a2b, amount, ignoreCache = true) {
    const liquidity = await getLiquidity(poolName, a2b, amount, ignoreCache);
    const numA = liquidity.coinAmountA.toString();
    const numB = liquidity.coinAmountB.toString();
    return [numA, numB];
}
async function getCoinAmountsFromLiquidity(poolName, liquidity, ignoreCache) {
    const clmmPool = await (0, getReceipts_js_1.getParentPool)(poolName, ignoreCache);
    const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
    const upper_bound = 443636;
    let lower_tick = Number(investor.content.fields.lower_tick);
    let upper_tick = Number(investor.content.fields.upper_tick);
    if (lower_tick > upper_bound) {
        lower_tick = -~(lower_tick - 1);
    }
    if (upper_tick > upper_bound) {
        upper_tick = -~(upper_tick - 1);
    }
    if (clmmPool) {
        const liquidityInt = Math.floor(parseFloat(liquidity));
        const coin_amounts = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(new bn_js_1.default(`${liquidityInt}`), new bn_js_1.default(clmmPool.content.fields.current_sqrt_price), cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(lower_tick), cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(upper_tick), true);
        return [coin_amounts.coinA.toString(), coin_amounts.coinB.toString()];
    }
    else {
        return ["0", "0"];
    }
}
async function getEstimatedGasBudget(tx, address) {
    const suiClient = (0, client_js_1.getSuiClient)();
    try {
        const simResult = await suiClient.devInspectTransactionBlock({
            transactionBlock: tx,
            sender: address,
        });
        return (Number(simResult.effects.gasUsed.computationCost) +
            Number(simResult.effects.gasUsed.nonRefundableStorageFee) +
            1e8);
    }
    catch (err) {
        console.error(`Error estimating transaction gasBudget`, err);
    }
}
//# sourceMappingURL=deposit.js.map